import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Box, Button, Container, Grid, IconButton, Skeleton, Typography } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import { getHomeCarousal } from '../../services/HomeCarousal';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const HomeSlider = () => {
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
  const swiperRef = useRef(null);
  const [homeCarousalData, setHomeCarousalData] = useState([])
  const navigate = useNavigate();

  const getHomeCarousalData = async () => {
    try {
      const response = await getHomeCarousal();
      setHomeCarousalData(response.homeCarousal);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getHomeCarousalData();
  }, []);

  return (
    <>
      {
        homeCarousalData?.length > 0 &&
        <Box
          sx={{
            bgcolor: '#f5f5f5',
            height: { sm: 'calc(80vh - 80px)', sm: '75vh', xs: '50vh' },
            position: 'relative'
          }}
        >
          <IconButton
            data-aos="fade-right"
            onClick={() => swiperRef.current?.slidePrev()}
            sx={{
              border: '1px solid #B8B8B8',
              color: '#fff',
              position: 'absolute',
              left: { lg: '5%', xs: '10px' },
              top: '50%',
              zIndex: 111
            }}>
            <KeyboardArrowLeftIcon sx={{
              fontSize: { lg: '40px', md: '30px' },
            }} />
          </IconButton>
          <Swiper
            className='home-slider'
            modules={[Navigation, Pagination, Autoplay]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            slidesPerView={1}
            spaceBetween={0}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto-slide every 3 seconds
            loop={true} // Enable infinite loop
          >
            {homeCarousalData?.map((slide, index) => (
              <SwiperSlide key={index}>
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                  {/* Background Overlay */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      width: '100%',
                      backgroundColor: '#000',
                      opacity: '50%',
                    }}
                  ></Box>

                  {/* Background Image */}
                  <Box
                    sx={{
                      backgroundImage: `url(${slide.image.url})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover', // Change from 'cover' to 'contain'
                      backgroundPosition: 'center', // Ensure the image is centered
                      height: { sm: 'calc(80vh - 80px)', sm: '75vh', xs: '50vh' }, // Adjust height as needed
                      width: '100%',
                    }}
                  >

                    <Container sx={{ zIndex: 1111, height: '100%' }}>
                      <Grid
                        container
                        alignItems="center"
                        sx={{ height: '100%' }}
                        justifyContent="center"
                      >
                        <Grid item sm={8} xs={12}>
                          <Box sx={{ position: 'relative', zIndex: 2 }}>
                            {/* Title with Fade-Up Animation */}
                            <Typography
                              variant={isSmallScreen ? 'h6' : isMediumScreen ? 'h5' : 'h4'}
                              sx={{
                                color: '#fff',
                                textAlign: 'center',
                                fontWeight: 700,
                                mt: isSmallScreen ? 1 : 2,
                                mb: isSmallScreen ? 1 : 3,
                              }}
                              data-aos="fade-up"
                            >
                              {slide.title}
                            </Typography>

                            {/* Content with Fade-Right Animation */}
                            <Typography
                              sx={{
                                color: '#fff',
                                textAlign: 'center',
                                fontSize: isLargeScreen ? '16px' : '24px',
                                lineHeight: isLargeScreen ? 'unset' : '36px',
                                display: isSmallScreen ? 'none' : 'block',
                              }}
                              data-aos="fade-right"
                            >
                              {slide.content}
                            </Typography>

                            {/* Button with Zoom-In Animation */}
                            <Box sx={{ textAlign: 'center' }} data-aos="zoom-in" >
                              <Button
                                className="hover-button"
                                sx={{
                                  borderColor: '#fff',
                                  backgroundColor: '#01A0E2',
                                  color: '#fff',
                                  borderRadius: '14px',
                                  mt: { sm: 4, xs: 2 },
                                  width: '160px',
                                  fontSize: { lg: '22px' }
                                }}
                                onClick={() => navigate("/product")}
                              >
                                Shop Now
                              </Button>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Container>
                  </Box>
                </Box>
              </SwiperSlide>

            ))}
          </Swiper>

          <IconButton
            data-aos="fade-left"
            onClick={() => swiperRef.current?.slideNext()}
            sx={{
              border: '1px solid #B8B8B8', color: '#fff',
              position: 'absolute',
              right: { lg: '5%', xs: '10px' },
              top: '50%',
              zIndex: 111
            }}>
            <KeyboardArrowRightIcon
              sx={{
                fontSize: { lg: '40px', md: '30px' },
              }} />
          </IconButton>
        </Box >
      }
    </>
  );
};

export default HomeSlider;